<template>
  <div class="bids-add-bulk-column-slider-navigation">
    <ElButton
      :disabled="isPrevDisabled"
      icon="el-icon-arrow-right"
      size="mini"
      @click="emitPrev"
    />
    <div class="bids-add-bulk-column-slider-navigation__left-nav-wrapper">
      <span class="bids-add-bulk-column-slider-navigation__found-columns">
        {{
          $tc(
            'ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_FOUND_COLUMNS',
            columnsCount,
          )
        }}
      </span>
      <ElButton
        :disabled="isNextDisabled"
        icon="el-icon-arrow-left"
        size="mini"
        @click="emitNext"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BidsAddBulkColumnSliderNavigation',
  props: {
    value: {
      type: Number,
      required: true,
    },
    columnsCount: {
      required: true,
      type: Number,
    },
    perRow: {
      required: true,
      type: Number,
    },
  },
  computed: {
    numberOfSlides() {
      return this.columnsCount > this.perRow
        ? this.columnsCount - this.perRow
        : 0;
    },
    isNextDisabled() {
      return this.value >= this.numberOfSlides;
    },
    isPrevDisabled() {
      return this.value === 0;
    },
  },
  methods: {
    emitPrev() {
      if (!this.isPrevDisabled) this.$emit('input', this.value - 1);
    },
    emitNext() {
      if (!this.isNextDisabled) this.$emit('input', this.value + 1);
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-column-slider-navigation {
  display: flex;
  justify-content: space-between;
  height: 40px;

  &__left-nav-wrapper {
    display: flex;
  }

  &__found-columns {
    margin-left: calc($global-margin / 2);
    align-self: center;
  }
}
</style>
